import client from "@irati/utils/services/apollo"
import {DealLocationFilterTags} from "@irati/types"

import locationFilterTagsQuery from "./queries/locationFilterTags"

class LocationFilterTagsService {
  get(): Promise<DealLocationFilterTags[]> {
    return client.query({query: locationFilterTagsQuery, fetchPolicy: "no-cache"}).then(({data}) => {
      return data.dealLocationFilterTags
    })
  }
}

const service = new LocationFilterTagsService()

export default service
